import { render } from "./Collections.vue?vue&type=template&id=56666d9d&scoped=true"
import script from "./Collections.vue?vue&type=script&lang=js"
export * from "./Collections.vue?vue&type=script&lang=js"

import "./Collections.vue?vue&type=style&index=0&id=56666d9d&scoped=true&lang=css"
import "./Collections.vue?vue&type=style&index=1&id=56666d9d&lang=css"
import "./Collections.vue?vue&type=style&index=2&id=56666d9d&scoped=true&lang=css"
import "./Collections.vue?vue&type=style&index=3&id=56666d9d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56666d9d"]])

export default __exports__